import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import KYCStatus from './KYCStatus';
import KYCForm from './KYCForm';
import KYCNotifications from './KYCNotifications';
import './KYCDashboard.css';

const KYCDashboard = () => {
  const { currentUser } = useAuth();
  const [showKYCForm, setShowKYCForm] = useState(false);
  const [merchantId, setMerchantId] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get merchant ID from user context or API
    if (currentUser) {
      setMerchantId(currentUser.id || currentUser.merchantId);
      setLoading(false);
    }
  }, [currentUser]);

  const handleStartKYC = () => {
    setShowKYCForm(true);
  };

  const handleBackToStatus = () => {
    setShowKYCForm(false);
  };

  if (loading) {
    return (
      <div className="kyc-dashboard-container">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading KYC Dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="kyc-dashboard-container">
      <div className="kyc-dashboard-header">
        <div className="header-content">
          <h1>KYC Verification</h1>
          <p>Complete your Know Your Customer (KYC) verification to start accepting payments</p>
        </div>
        <div className="header-actions">
          <button onClick={() => window.location.href = '/dashboard'}
            style={{ padding: '10px 20px', background: '#6c757d', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', marginRight: '8px' }}>
            ← Back to Dashboard
          </button>
          <button 
            className="btn btn-help"
            onClick={() => window.location.href = '/kyc/help'}
          >
            ❓ Need Help?
          </button>
        </div>
      </div>

      {showKYCForm ? (
        <div className="kyc-form-section">
          <div className="back-button-container">
            <button 
              className="btn btn-secondary back-button"
              onClick={handleBackToStatus}
            >
              ← Back to Status
            </button>
          </div>
          <KYCForm 
            merchantId={merchantId} 
            onComplete={handleBackToStatus}
          />
        </div>
      ) : (
        <div className="kyc-status-section">
          <div className="kyc-main-content">
            <div className="kyc-status-column">
              <KYCStatus 
                merchantId={merchantId} 
                onStartKYC={handleStartKYC}
              />
            </div>
            <div className="kyc-notifications-column">
              <KYCNotifications merchantId={merchantId} />
            </div>
          </div>
          
          <div className="kyc-info-cards">
            <div className="info-card">
              <div className="info-icon">📋</div>
              <h3>Required Documents</h3>
              <ul>
                <li>PAN Card (Mandatory)</li>
                <li>Address Proof (Aadhaar/Passport)</li>
                <li>Cancelled Cheque or Bank Statement</li>
                <li>GST Certificate (If applicable)</li>
                <li>Business Registration (If applicable)</li>
              </ul>
            </div>
            
            <div className="info-card">
              <div className="info-icon">⚡</div>
              <h3>Quick Verification</h3>
              <ul>
                <li>Real-time PAN verification</li>
                <li>Instant GST validation</li>
                <li>Penny drop bank verification</li>
                <li>Automated document processing</li>
                <li>24-48 hour approval</li>
              </ul>
            </div>
            
            <div className="info-card">
              <div className="info-icon">🔒</div>
              <h3>Secure & Compliant</h3>
              <ul>
                <li>Bank-grade security</li>
                <li>RBI compliant process</li>
                <li>Encrypted data storage</li>
                <li>GDPR compliant</li>
                <li>Regular security audits</li>
              </ul>
            </div>
          </div>
          
          <div className="kyc-benefits">
            <h2>Why Complete KYC?</h2>
            <div className="benefits-grid">
              <div className="benefit-item">
                <div className="benefit-icon">💳</div>
                <h4>Accept Payments</h4>
                <p>Start accepting payments from customers through multiple payment methods</p>
              </div>
              <div className="benefit-item">
                <div className="benefit-icon">📈</div>
                <h4>Higher Limits</h4>
                <p>Unlock higher transaction limits and better settlement terms</p>
              </div>
              <div className="benefit-item">
                <div className="benefit-icon">🛡️</div>
                <h4>Trust & Security</h4>
                <p>Build customer trust with verified merchant status</p>
              </div>
              <div className="benefit-item">
                <div className="benefit-icon">📊</div>
                <h4>Analytics</h4>
                <p>Access detailed transaction analytics and reporting</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default KYCDashboard;